var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgReflection = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 61 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 0a4 4 0 0 1 4 4v32.343l19.672-19.671A4 4 0 0 1 60.5 19.5v49a4 4 0 0 1-6.828 2.828L34 51.657V82a4 4 0 0 1-8 0V52.157L6.828 71.328A4 4 0 0 1 0 68.5v-49a4 4 0 0 1 6.828-2.828L26 35.843V4a4 4 0 0 1 4-4Zm7.657 44L52.5 58.843V29.157L37.657 44ZM8 58.843 22.843 44 8 29.157v29.686Z",
  fill: "#00A2AA"
})));

export default SvgReflection;